var map = {
	"./BTCB.json": 994,
	"./BUSD.json": 995,
	"./BinarySubscription.json": 996,
	"./BitopexToken.json": 997,
	"./BusinessParcel.json": 998,
	"./CashFT.json": 999,
	"./ETH.json": 1000,
	"./FileCoin.json": 1001,
	"./GymAgregator.json": 1002,
	"./GymNetwork.json": 1003,
	"./GymRouter.json": 1004,
	"./GymStreetFarming.json": 1005,
	"./GymStreetLevelPool.json": 1006,
	"./MLM.json": 1007,
	"./MiningSC.json": 1008,
	"./MlmQualification.json": 1009,
	"./MonthlyTaxPool.json": 1010,
	"./MysteryBox.json": 1011,
	"./NetGymStreet.json": 1012,
	"./NftReflection.json": 1013,
	"./PANCAKE_FACTORY.json": 1014,
	"./PancakeRouter.json": 1015,
	"./PendingCommissionActivation.json": 1016,
	"./SignatureValidatorUM.json": 1017,
	"./SinglePool.json": 1018,
	"./SinglePoolPendingCommission.json": 1019,
	"./TurnoverPool.json": 1020,
	"./USDT.json": 1021,
	"./Vaults.json": 1022,
	"./WBNB.json": 1023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1822;